import OrderAction from './orderAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../models/orderModel';
import DownloadTicketActionAttendee from '../../../pages/attendee/actions/downloadTicketActions';

export default class DownloadTicketsAction extends OrderAction {
    static NAME = 'download_tickets';
    static NAME_ORDER = 'download_ticket_pdf';

    static condition(order) {
        return ['valid'].includes(order.status) && order.attendee_count > order.attendees_deleted_count;
    }

    static is_attendee_valid({ attendee, order }) {
        return DownloadTicketActionAttendee.is_attendee_valid({ attendee, order });
    }

    //global
    get is_direct() {
        return Array.isArray(this.items) && this.items.length > 1;
    }

    get needs_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return (Array.isArray(this.items) && this.items.length === 1) || !Array.isArray(this.items);
    }

    run({ orders = null, attendees = null }) {
        if (attendees) {
            //only not deleted
            const to_download = attendees.filter(a => !a.removed);
            return Attendee.perform_action(DownloadTicketActionAttendee.NAME, to_download, { organization: this.organization, event: this.event });
        }
        const items_to_download = orders || this.filtered_items;
        return Order.perform_action(items_to_download.length === 1 ? this.constructor.NAME_ORDER : this.constructor.NAME, items_to_download, {
            organization: this.organization,
            event: this.event
        });
    }

    onActionDone() {
        this.onClose();
    }
}
